<template>
  <div id="forgot">
    <br />
    <br />
    <br />
    <Button
      label="Back"
      @click="GoBack()"
      icon="pi pi-arrow-left"
      iconPos="left"
    />
    <h2>Forgot Password</h2>
    <span class="p-input-icon-left">
      <i class="pi pi-user" />
      <InputText type="text" v-model="email" placeholder="Email" /> </span
    ><br />

    <!-- <br/>
    <span class="p-input-icon-left">
      <i class="pi pi-lock" />
      <InputText type="password" v-model="password" placeholder="Password" />
    </span><br/> -->
    <Button
      class="p-m-2"
      label="Log in"
      @click="loginUser()"
      icon="pi pi-sign-in"
      iconPos="right"
    />
    <br />
    <Toast position="bottom-center" />
    <p>
      If you have lost your password, <br /><b>request a password reset</b> by
      submitting here. <br />You will receive and email shortly. <br /><br />If
      you need further assistance please send an email to graham.denoyer@gmail.com
    </p>
    <br />
    <p class="details">
      <!-- <small class="level-item" style="color: var(--textLight)">
        This product is developed and managed by CW3 Graham DeNoyer.
      </small> -->
    </p>
  </div>
</template>

<script>
import { fb_auth } from "../firebase";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    GoBack() {
      this.$router.push({ path: "/" });
    },
    loginUser() {
      if (this.email && this.password) {
        fb_auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            console.log("user:", fb_auth.currentUser);
            this.$router.push({ path: "/home" });
            //route to home
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: "errorcode",
              detail: "Login Message",
              life: 3000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Form Incomplete",
          detail: this.email
            ? "Password cannot be empty."
            : "Email cannot be empty",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;
}
</style>